import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('useStripe');

    return {
        APPLYING_TRIAL_DISCOUNT_ERROR_MESSAGE: t('applyingTrialDiscountErrorMessage'),
        FETCHING_CUSTOMER_PORTAL_ERROR_MESSAGE: t('fetchingCustomerPortalErrorMessage'),
        FETCHING_CUSTOMER_SECRET_ERROR_MESSAGE: t('fetchingCustomerSecretErrorMessage'),
        FETCHING_SUBSCRIPTIONS_ERROR_MESSAGE: t('fetchingSubscriptionsErrorMessage')
    };
};

export default useTranslation;
